/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-02-21 10:50:43
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  placeholder: '请选择',
  placeholderInput: '请输入',
  timeZone: '时区',
  setTime: '设置时间',
  manual: '手动的',
  auto: '自动使用指定的NTP服务器',
  time: '时间',
  NTP: 'NTP服务器',
  title: '修改环境时间',
  confirmSysTime: '确认环境时间',
  rules: '格式不正确',
  tip: '选择的时间不能小于当前系统时间',
  synchronizing: '同步中',
});
